module.exports = __webpack_public_path__ + "static/procesKreacjaDesktop@x1-36b22d85b1a7170dc7713b114c20c746.png";